import React from "react";
import { Provider } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import thunkMiddleware from "redux-thunk";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Home from "./containers/home/";
import Outlet from "./containers/outlet/";
import NewVehicles from "./containers/newVehicles/";
import Detail from "./containers/detail/";
import Buy from "./containers/buy/";
import Credit from "./containers/credit/";
import Request from "./containers/request/";
import Bring from "./containers/bring/";
import SellUsedVehicle from "./containers/sell/";
import Contact from "./containers/contact/";
import StoriesModal from "components/organisms/StoriesModal";

import reducers from "./reducers";

import "./resources/scss/main.scss";

const store = createStore(reducers, applyMiddleware(thunkMiddleware));

function App() {
  return (
    <Provider store={store}>
      <Router basename={process.env.NODE_ENV === "production" ? "/usados" : ""}>
        <Switch>
          <Route path="/" component={Home} exact />
          <Route path="/outlet" component={Outlet} exact />
          <Route path="/usados-sin-rodar" component={NewVehicles} exact />
          <Route path="/usado/:id" component={Detail} exact />
          <Route path="/reservar-usado/:id" component={Buy} exact />
          <Route path="/credit" component={Credit} exact />
          <Route path="/pedi-tu-usado" component={Request} exact />
          <Route path="/usados-buenos-aires" component={Bring} exact />
          <Route path="/compramos-tu-usado" component={SellUsedVehicle} exact />
          <Route path="/consultar/:id" component={Contact} exact />
          <Route path="/historias/:id/:title" component={StoriesModal} exact />
        </Switch>
      </Router>
    </Provider>
  );
}

export default App;
